import React from "react";

import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";

import { FieldErrors } from "src/api/types";
import { Switch } from "src/base-components/Switch";
import { FileExtractionRow } from "src/customConnectionNode/editorComponents/FileExtractionRow";
import {
  CustomConnectionForm,
  getDefaultFileExtractionEntry,
} from "src/customConnectionNode/types";
import { Button } from "src/design-system/Button";

type Props = {
  immutable: boolean;
  runFieldErrors: FieldErrors | undefined;
};

export const FileExtractionEditor: React.FC<Props> = ({
  immutable,
  runFieldErrors,
}) => {
  const { control, watch } = useFormContext<CustomConnectionForm>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "config.file_extraction_config.extractions",
    keyName: "_id",
  });
  const isActive = watch("config.file_extraction_config.active");

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h3 className="font-inter-medium-12px text-gray-800">
            Enable file extraction
          </h3>
          <span className="font-inter-normal-12px text-gray-500">
            Extract one or more files from the response and map each file id
            into the data object.
          </span>
        </div>
        <Controller
          control={control}
          name="config.file_extraction_config.active"
          render={({ field }) => (
            <Switch
              dataLoc="cc-node-file-extraction-active"
              disabled={immutable}
              enabled={!!field.value}
              onChange={() => field.onChange(!field.value)}
            />
          )}
        />
      </div>

      {isActive && (
        <>
          {fields.map((field, index) => (
            <FileExtractionRow
              key={field._id}
              immutable={immutable}
              index={index}
              runFieldErrors={runFieldErrors}
              onRemove={() => remove(index)}
            />
          ))}

          {!immutable && (
            <Button
              dataLoc="cc-node-file-extraction-add"
              iconLeft={faPlus}
              size="sm"
              variant="secondary"
              onClick={() => append(getDefaultFileExtractionEntry())}
            >
              Add file
            </Button>
          )}
        </>
      )}
    </>
  );
};
